// Only the portal admin resource page still uses this — the share handlers that used to
// live here went with the B2C resource library (removed 2026-07-29).
$(function() {
	if (typeof ClipboardJS === 'undefined' || $('.copy-link').length === 0) return;

	var copyLink = new ClipboardJS('.copy-link');
	copyLink.on('success', function(e) {
		alert("Copied the text: " + e.text);
	});
});
